export const spriteVersion = "2";
export const spritePaths = {
    default: "/assets/images/icons/sprite.svg",
    brands: "/assets/images/icons/brands-sprite.svg",
    marketing: "/assets/images/icons/marketing-sprite.svg",
    vaLoans: "/assets/images/icons/va-loans-sprite.svg",
};
export function spriteHref(path, symbol) {
    const separator = path.includes("?") ? "&" : "?";
    return `${path}${separator}v=${spriteVersion}#${symbol}`;
}
